import React from "react";
import { Typography } from "@mui/material";

const Overview = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Overview
      </Typography>
      <Typography variant="body2">
        Nominatim indexes named (or numbered) features within the OpenStreetMap (OSM) dataset and a
        subset of other unnamed features (pubs, hotels, churches, etc).
      </Typography>
    </>
  );
};

export default Overview;
